"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import s from "underscore.string";
import _ from "underscore";
import loadHelper from "./loads";
import Api from "../api/api";
import "../api/account";
import ruleFormatter from "../formatters/rules";
import { splitReferences } from "../helpers/references";
import { escapeRegExp } from "../util/strings";
import generalFormatter from "../formatters/general";
const renderTemplate = (templateString, templateVariables, user, loadState, invoices, carrier, options = {}) => {
  const scope = {
    user,
    loadState,
    invoices,
    carrier,
    invoice: invoices[0],
    load: loadState && loadState.load
  };
  const expansionMap = expansions(scope);
  templateString = _.foldl(
    templateVariables,
    (template, variable) => {
      if (expand(expansionMap, variable, scope, options)) {
        template = template.replace(
          new RegExp(`{#if ${variable}}(.*?){#endif}`, "g"),
          "$1"
        );
      } else {
        template = template.replace(
          new RegExp(`{#if ${variable}}.*?{#endif}`, "g"),
          ""
        );
      }
      return replaceVariable(template, variable);
    },
    templateString
  );
  templateString = _.foldl(
    Object.keys(expansionMap),
    replaceVariable,
    templateString
  );
  return templateString;
  function replaceVariable(template, variable) {
    const escapedVariable = escapeRegExp(variable);
    return template.replace(
      new RegExp(escapedVariable, "g"),
      expand(expansionMap, variable, scope, options)
    );
  }
};
const expand = (expansionMap, variable, scope, options) => {
  const expansion = expansionMap[variable];
  if (expansion) {
    const value = expansion(scope);
    if (options.blankMissing && (value == null || value === "null")) {
      return "";
    }
    return value;
  } else {
    console.log(`unhandled variable ${variable}`);
    return "";
  }
};
function expansions(scope) {
  if (Api.Account.hasRole("Factor")) {
    return factorExpansions;
  } else {
    return __spreadValues(__spreadValues({}, brokerExpansions), buildReferenceExpansions(scope.load, (x) => `<${x}>`));
  }
}
const factorExpansions = {};
const brokerExpansions = {};
const accountName = ({ user }) => user.account.name;
brokerExpansions["{account_name}"] = accountName;
brokerExpansions["{ship_date}"] = ({ load }) => {
  if (load && load.actual_shipped_at) {
    return generalFormatter.longDate(load.actual_shipped_at);
  } else {
    return "null";
  }
};
brokerExpansions["{invoiced_amount}"] = ({ invoice }) => {
  if (invoice && invoice.source_invoice_amount) {
    return generalFormatter.currency(invoice.source_invoice_amount);
  } else {
    return "null";
  }
};
brokerExpansions["{expected_amount}"] = ({ invoice }) => {
  if (invoice) {
    return generalFormatter.currency(invoice.remaining_charge);
  }
};
brokerExpansions["{load_status}"] = ({ load }) => {
  if (load && load.status) {
    return load.status;
  } else {
    return "null";
  }
};
brokerExpansions["{variance_amount}"] = ({ invoice }) => {
  if (invoice && invoice.remaining_charge && invoice.source_invoice_amount) {
    const variance = invoice.remaining_charge - invoice.source_invoice_amount;
    return generalFormatter.currency(variance);
  } else {
    return "null";
  }
};
brokerExpansions["{customer_charge}"] = ({ load }) => {
  if (load && load.customer_charge) {
    return generalFormatter.currency(load.customer_charge);
  } else {
    return "null";
  }
};
brokerExpansions["{weight}"] = ({ load }) => {
  if (load && load.weight) {
    return generalFormatter.weight(load.weight);
  } else {
    return "null";
  }
};
brokerExpansions["{freight_class}"] = ({ load }) => {
  if (load && load.freight_class) {
    return load.freight_class;
  } else {
    return "null";
  }
};
brokerExpansions["{account_number}"] = ({ load }) => {
  if (load && load.customer && load.customer.account_number) {
    return load.customer.account_number;
  } else {
    return "null";
  }
};
brokerExpansions["{invoice_number}"] = ({ invoice }) => invoice.source_invoice_number;
brokerExpansions["{carrier_name}"] = ({ carrier }) => {
  if (carrier && carrier.name) {
    return carrier.name;
  } else {
    return "null";
  }
};
brokerExpansions["{load_id}"] = ({ loadState }) => {
  if (loadState && loadState.load) {
    return loadState.load.load_id;
  } else {
    return "null";
  }
};
brokerExpansions["{exception_summary}"] = ({ invoice }) => {
  if (invoice) {
    return loadHelper.exceptionSummary(invoice);
  } else {
    return "null";
  }
};
brokerExpansions["{exception_messages}"] = ({ loadState, invoice }) => {
  const prePependText = "    ";
  const messages = _.map(
    loadHelper.allExceptionMessages(
      invoice,
      loadState,
      false,
      prePependText,
      true
    ),
    (message) => {
      return message;
    }
  );
  return messages.join("\n");
};
brokerExpansions["{signature}"] = ({ user }) => {
  if (!s.isBlank(user.settings.exceptions_signature)) {
    return user.settings.exceptions_signature;
  } else {
    return `

Thanks,

${user.name}`;
  }
};
factorExpansions["{account_name}"] = accountName;
factorExpansions["{invoice_number}"] = ({ invoice }) => invoice.source_invoice_number;
factorExpansions["{carrier_name}"] = ({ carrier }) => {
  if (carrier) {
    return carrier.name;
  }
};
factorExpansions["{load_id}"] = ({ invoice }) => invoice.load_id;
factorExpansions["{exception_summary}"] = ({ invoice }) => {
  return loadHelper.exceptionSummary(invoice);
};
factorExpansions["{exception_messages}"] = ({ invoice }) => {
  const rules = loadHelper.enabledRules(invoice);
  const publicRules = _.reject(rules, _.property("internal_failure"));
  const ruleMessages = _.map(publicRules, function(rule) {
    return "    " + ruleFormatter.ruleAsClientText(rule);
  });
  const exceptionMessages = _.map(
    invoice.exception_events,
    (e) => `    ${e.message_override}`
  );
  return exceptionMessages.concat(ruleMessages).join("\n");
};
factorExpansions["{signature}"] = ({ user }) => {
  if (!s.isBlank(user.settings.exceptions_signature)) {
    return user.settings.exceptions_signature;
  } else {
    return "";
  }
};
const addExpansionForReferenceVariable = (variableName, referenceName, referenceSourceFn) => {
  brokerExpansions[variableName] = (scope) => {
    const source = referenceSourceFn(scope);
    if (source) {
      return source.references[referenceName];
    } else {
      return "";
    }
  };
};
addExpansionForReferenceVariable(
  "{order_ids}",
  "Order IDs",
  ({ load }) => load
);
addExpansionForReferenceVariable("{order_id}", "Order ID", ({ load }) => load);
function buildReferenceExpansions(referenceSource, variableFormatter) {
  const dynamicExpansions = {};
  const references = referenceSource && referenceSource.references || {};
  Object.entries(references).forEach(([referenceName, referenceValue]) => {
    dynamicExpansions[variableFormatter(referenceName)] = (_2) => {
      return splitReferences(referenceValue).join(", ");
    };
  });
  return dynamicExpansions;
}
export { renderTemplate };
